var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"archivoContainer"},_vm._l((_vm.archivos),function(item){return _c('div',{key:item.Id},[_c('ArchivoCard',{attrs:{"archivo":item,"esBusqueda":false}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }